const plugin = require('tailwindcss/plugin')

module.exports = plugin(function ({ addUtilities, config }) {
  const theme = config('theme')

  const Tracklines = {}

  addUtilities(Tracklines, ['before'])
})
